export default __webpack_public_path__ + "static/media/liquidity.89ec98e5.png";